import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  container: {
    '& > $iconButton': {
      '&:last-of-type': {
        marginRight: 0,
      },
      marginRight: theme.spacing(),
    },
  },
  iconButton: {
    '&:hover': {
      background: 'none',
    },
    padding: 0,
  },
}));

export default useStyles;
